import { supabase } from '../lib/supabase';

class RealtimeService {
  constructor() {
    this.subscriptions = new Map();
  }

  /**
   * Subscribe to phase progress updates for a specific project
   * @param {string} projectId - The project ID to subscribe to
   * @param {function} callback - Callback function to handle updates
   * @returns {object} Subscription object
   */
  subscribeToPhaseUpdates(projectId, callback) {
    const channelName = `phase-updates-${projectId}`;

    // Remove existing subscription if any
    if (this.subscriptions?.has(channelName)) {
      this.unsubscribe(channelName);
    }

    // Create new subscription
    const channel = supabase
      ?.channel(channelName)
      ?.on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'phases',
          filter: `project_id=eq.${projectId}`
        },
        (payload) => {
          console.log('Phase update received:', payload);
          callback(payload?.new);
        }
      )
      ?.subscribe((status) => {
        console.log(`Subscription status for ${channelName}:`, status);
      });

    this.subscriptions?.set(channelName, channel);
    return channel;
  }

  /**
   * Subscribe to phase updates for multiple projects
   * @param {array} projectIds - Array of project IDs
   * @param {function} callback - Callback function to handle updates
   */
  subscribeToMultipleProjects(projectIds, callback) {
    projectIds?.forEach((projectId) => {
      this.subscribeToPhaseUpdates(projectId, callback);
    });
  }

  /**
   * Subscribe to all phase updates (for boss view)
   * @param {function} callback - Callback function to handle updates
   * @returns {object} Subscription object
   */
  subscribeToAllPhaseUpdates(callback) {
    const channelName = 'all-phase-updates';

    // Remove existing subscription if any
    if (this.subscriptions?.has(channelName)) {
      this.unsubscribe(channelName);
    }

    // Create new subscription
    const channel = supabase
      ?.channel(channelName)
      ?.on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'phases'
        },
        (payload) => {
          console.log('Phase update received (all):', payload);
          callback(payload?.new);
        }
      )
      ?.subscribe((status) => {
        console.log(`Subscription status for ${channelName}:`, status);
      });

    this.subscriptions?.set(channelName, channel);
    return channel;
  }

  /**
   * Unsubscribe from a specific channel
   * @param {string} channelName - The channel name to unsubscribe from
   */
  unsubscribe(channelName) {
    const channel = this.subscriptions?.get(channelName);
    if (channel) {
      supabase?.removeChannel(channel);
      this.subscriptions?.delete(channelName);
      console.log(`Unsubscribed from ${channelName}`);
    }
  }

  /**
   * Unsubscribe from all channels
   */
  unsubscribeAll() {
    this.subscriptions?.forEach((channel, channelName) => {
      supabase?.removeChannel(channel);
      console.log(`Unsubscribed from ${channelName}`);
    });
    this.subscriptions?.clear();
  }
}

export const realtimeService = new RealtimeService();
export default realtimeService;